/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByDataSourceKind = (typeof GroupByDataSourceKind)[keyof typeof GroupByDataSourceKind];

export const GroupByDataSourceKind = {
  data_source: 'data_source',
} as const;
